import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { MenuPermisos } from './models/permisos.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from 'app/core/user/user.service';

@Injectable({providedIn: 'root'})
export class RolesPermisosService {

    rol: BehaviorSubject<Tipologia> = new BehaviorSubject(null)
    permisosUsuario: BehaviorSubject<MenuPermisos[]> = new BehaviorSubject([])

    get rol$(): Observable<Tipologia> {
        return this.rol.asObservable()
    }

    get permisosUsuario$(): Observable<MenuPermisos[]> {
        return this.permisosUsuario.asObservable()
    }


    constructor(private apiService:ApiService,
        private _userService:UserService
    ) { }

    getColeccionistas(tipologiaId:number){
            const url= `/tipologias/${tipologiaId}`
            return new Promise((resolve, reject)=>{
                        this.apiService.GetMethod(url, {}, 'Error al obtener listado de roles.')
                           .subscribe((response:TipologiasInterface) => {
                                resolve(response[0].tipologias)  
                            }, error => {
                                reject(error)
                            })
                    })
        }

    getPermisos(params?:any): Promise<MenuPermisos[]>{
        const url= `/permisos`
        return new Promise((resolve, reject)=>{
                    this.apiService.GetMethod(url, params, 'Error al obtener listado de permisos.')
                        .subscribe((response: MenuPermisos[]) => {
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }

    postRol(body?:any){
        const url= `/tipologias/roles`
        return new Promise((resolve, reject)=>{
                    this.apiService.PostMethod(url, body, {}, 'Error al guardar rol.')
                        .subscribe((response) => {
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }

    postPermisosList(body:any){
        const url= `/permisos/rol/asignar`
        return new Promise((resolve, reject)=>{
                    this.apiService.PostMethod(url, body, {}, 'Error al actualizar permisos.')
                        .subscribe((response) => {
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }

    getPermisosByRol(rol_id:number): Promise<MenuPermisos[]>{
        const url= `/permisos/rol/obtener/${rol_id}`
        return new Promise((resolve, reject)=>{
                    this.apiService.GetMethod(url, {}, 'Error al obtener permisos.')
                        .subscribe((response:MenuPermisos[]) => {
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }
    
    eliminarRol(rol_id:number){
        const url= `/tipologias/roles/${rol_id}`
        return new Promise((resolve, reject)=>{
                    this.apiService.DeleteMethod(url, {}, 'Error al eliminar rol.')
                        .subscribe((response) => {
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }

    getRol(rol_id:number){
        const url= `/tipologias/${rol_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener rol.')
                .subscribe((response:Tipologia[]) => {
                    this.rol.next(response[0])
                    resolve(response[0])  
                }, error => {
                    reject(error)
                })
        })
    }
    

    getPermisosUser(){
        const userRol_uuid = parseInt(this._userService.usuarioLogueadoValues.rol_id);
        const url= `/permisos/rol/obtener/${userRol_uuid}`
        return new Promise((resolve, reject)=>{
                    this.apiService.GetMethod(url, {}, 'Error al obtener permisos.')
                        .subscribe((response:MenuPermisos[]) => {
                            this.permisosUsuario.next(response)
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }
}